{
  "abacus_event_id": 177052,
  "created_by": "",
  "event_date": "2021-07-11T11:20:35.45+01:00",
  "event_name": "adjustment_file_upload",
  "statement_period_id": 317,
  "target_id": 2077,
  "target_ids": [2077, 2086, 2089, 2090],
  "target_type": "statement_period_adjustment_file"
}
